/**
 * WeaponXP — Weapons gain experience as used (Minecraft doesn't have this).
 *
 * Each sword/bow/tool tracks hits/mines. At thresholds, it levels up:
 * - Level 1 (0-20 uses):   +0% damage
 * - Level 2 (20-60 uses):  +10% damage
 * - Level 3 (60-150 uses): +25% damage
 * - Level 4 (150-400):     +50% damage
 * - Level 5 (400+):        +100% damage (Legendary)
 *
 * Shown in item tooltip and hotbar.
 */

const LEVEL_THRESHOLDS = [0, 20, 60, 150, 400];
const LEVEL_DAMAGE_MULT = [1.0, 1.1, 1.25, 1.5, 2.0];
const LEVEL_NAMES = ['Común', 'Usado', 'Experto', 'Maestro', 'Legendario'];
const LEVEL_COLORS = ['#CCCCCC', '#A4FFFF', '#88FF88', '#FFD700', '#FF44FF'];

export function getWeaponLevel(tool) {
  if (!tool || typeof tool.uses !== 'number') return 0;
  for (let i = LEVEL_THRESHOLDS.length - 1; i >= 0; i--) {
    if (tool.uses >= LEVEL_THRESHOLDS[i]) return i;
  }
  return 0;
}

export function getWeaponDamageMult(tool) {
  return LEVEL_DAMAGE_MULT[getWeaponLevel(tool)];
}

export function getWeaponLevelName(tool) {
  return LEVEL_NAMES[getWeaponLevel(tool)];
}

export function getWeaponLevelColor(tool) {
  return LEVEL_COLORS[getWeaponLevel(tool)];
}

/**
 * Increment weapon uses on successful hit.
 * Returns true if weapon leveled up.
 */
export function incrementWeaponUses(tool) {
  if (!tool) return false;
  const before = getWeaponLevel(tool);
  tool.uses = (tool.uses || 0) + 1;
  const after = getWeaponLevel(tool);
  return after > before;
}

/**
 * Get progress to next level (0.0 to 1.0).
 */
export function getWeaponLevelProgress(tool) {
  if (!tool || typeof tool.uses !== 'number') return 0;
  const level = getWeaponLevel(tool);
  if (level >= LEVEL_THRESHOLDS.length - 1) return 1;
  const current = LEVEL_THRESHOLDS[level];
  const next = LEVEL_THRESHOLDS[level + 1];
  return Math.min(1, (tool.uses - current) / (next - current));
}
